/**
 * Camera functionality, including the smooth camera position, and ensuring the
 * camera only sits on round pixel values to keep things nice and crisp.
 *
 * @type {Object}
 */
Game.Utils.Camera = {


	// get x() {
	// 	return game.camera.x;
	// },
	//
	// set x( value ) {
	// 	game.camera.x = value;
	// },
	//
	//

	/**
	 * Initialize the camera properties that will be reused throughout the game.
	 */
	init: function() {

	},


	/**
	 * Set the target for the camera to follow.
	 *
	 * @param  {Skier} target The skier to follow.
	 */
	set_target: function( target ) {

		game.camera.follow( target );

		var w = Math.round( game.height / 16 );
		var h = Math.round( game.height / 5.333 );
		game.camera.deadzone = new Phaser.Rectangle(
			Math.round( ( game.width - w ) / 2 ),
			Math.round( ( game.height - h ) / 2 + h * 0.3 ),
			w,
			h
		);

		console.log( game.camera.deadzone );

	},


};
